/**
 * Section Components - Schema-driven detail sections
 *
 * Each section type maps to a single React component.
 * Used by SectionRenderer to render entity details based on ENTITY_SCHEMA.
 */

// Types
export type { SectionType, SectionConfig, EntitySchema, DateField, SectionProps } from './types';

// Section Components
export { ImageSection } from './image-section';
export { StatusSection } from './status-section';
export { DatesSection } from './dates-section';
export { AmountSection } from './amount-section';
export { PartySection } from './party-section';
export { ItemsSection } from './items-section';
export { ResponsesSection } from './responses-section';
export { StatsSection } from './stats-section';
export { ListSection } from './list-section';
export { ContactSection } from './contact-section';
export { ProductsSection } from './products-section';
export { CollectionsSection } from './collections-section';
export { TextSection } from './text-section';
export { TagsSection } from './tags-section';
export { IntentLinesSection } from './intent-lines-section';
export { AxisWeightsSection } from './axis-weights-section';
export { AxisBreakdownSection } from './axis-breakdown-section';
export { MetadataSection } from './metadata-section';
export { OdooLinkSection } from './odoo-link-section';
export { CcFunctionsSection } from './cc-functions-section';
export { SectionSkeleton } from './section-skeleton';
